import React, { useState } from 'react';
import Link from 'next/link';
import AtvImg from 'react-scale/components/elements/atv';
import { useKeenSlider } from 'keen-slider/react';
import { Section } from 'react-scale/components';
import 'keen-slider/keen-slider.min.css';
import Image from 'next/image';
import cn from 'classnames';

import s from './highlight-datasets.module.css';

const HighlightDatasets = ({ datasets }) => {
  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, slider] = useKeenSlider({
    created() {
      setLoaded(true);
    },
    loop: false,
    slides: {
      origin: 'center',
      spacing: 32,
      perView: 'auto'
    },
    rtl: false,
    slideChanged(_slider) {
      setCurrentSlide(_slider.track.details.rel);
    }
  });

  return (
    <Section bg="bg-neutral-800" container={false} paddingBottom={false} paddingTop={false}>
      <div className="py-24">
        <ul ref={sliderRef} className="md:!hidden keen-slider mb-12">
          {datasets.map(dataset => {
            if (dataset.href.includes('http')) {
              return (
                <li key={dataset.href} className={cn(s['dataset-card'], 'keen-slider__slide')}>
                  <a
                    href={dataset.href}
                    className="w-full h-full"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      src={dataset.src.full}
                      layout="fill"
                      loading="eager"
                      quality={100}
                      objectFit="cover"
                    />
                  </a>
                </li>
              );
            }
            return (
              <li key={dataset.href} className={cn(s['dataset-card'], 'keen-slider__slide')}>
                <Link
                  href={dataset.href}
                  className="w-full h-full"
                  target="_blank"
                  rel="noopener noreferrer">

                  <Image src={dataset.src.full} layout="fill" loading="eager" quality={100} />

                </Link>
              </li>
            );
          })}
        </ul>

        {loaded && slider && (
          <div className="flex justify-center mx-auto space-x-2 max-w-max md:hidden">
            {[...Array(slider.current.slides.length).keys()].map(idx => (
              <span
                key={idx}
                onClick={() => slider.current?.moveToIdx(idx)}
                className={cn(
                  'rounded-full w-[10px] h-[10px]',
                  currentSlide === idx ? 'bg-white' : 'bg-[#37383B]'
                )}
              />
            ))}
          </div>
        )}

        <ul className="container hidden grid-cols-2 md:grid gap-y-3 md:gap-y-0 gap-x-3 md:gap-x-6 md:grid-cols-5">
          {datasets.map(dataset => {
            if (dataset.href.includes('http')) {
              return (
                <li key={dataset.href} style={{ transform: 'translateZ(0)' }}>
                  <div className="relative" style={{ paddingBottom: '136%' }}>
                    <a
                      className="absolute inset-0"
                      href={dataset.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <AtvImg
                        layers={[dataset.src.back, dataset.src.front].filter(
                          layer => layer !== undefined
                        )}
                        staticFallback={dataset.src.full}
                        style={{ width: '100%', height: '100%' }}
                      />
                    </a>
                  </div>
                </li>
              );
            }
            return (
              <li key={dataset.href} style={{ transform: 'translateZ(0)' }}>
                <div className="relative" style={{ paddingBottom: '136%' }}>
                  <Link href={dataset.href} className="absolute inset-0">

                    <AtvImg
                      layers={[dataset.src.back, dataset.src.front].filter(
                        layer => layer !== undefined
                      )}
                      staticFallback={dataset.src.full}
                      style={{ width: '100%', height: '100%' }}
                    />

                  </Link>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </Section>
  );
};

HighlightDatasets.defaultProps = {
  background: '#262626',
  withPadding: true,
  container: true,
  datasets: [
    {
      src: {
        full: '/static/images/pages/open-datasets/oxford/oxford.svg',
        front: '/static/images/pages/open-datasets/oxford/oxford-front.svg',
        back: '/static/images/pages/open-datasets/oxford/oxford-back.svg'
      },
      href: '/open-av-datasets/oxford'
    },
    {
      src: {
        full: '/static/images/pages/open-datasets/waterloo/waterloo.svg',
        front: '/static/images/pages/open-datasets/waterloo/waterloo-front.svg',
        back: '/static/images/pages/open-datasets/waterloo/waterloo-back.svg'
      },
      href: '/open-av-datasets/waterloo'
    },
    {
      src: {
        full: '/static/images/pages/open-datasets/lyft/lyft.svg',
        front: '/static/images/pages/open-datasets/lyft/lyft-front.svg',
        back: '/static/images/pages/open-datasets/lyft/lyft-back.svg'
      },
      href: 'https://level5.lyft.com/dataset'
    },
    {
      src: {
        full: '/static/images/pages/open-datasets/pandaset/pandaset.svg',
        front: '/static/images/pages/open-datasets/pandaset/pandaset-front.svg',
        back: '/static/images/pages/open-datasets/pandaset/pandaset-back.svg'
      },
      href: '/open-av-datasets/pandaset'
    },
    {
      src: {
        full: '/static/images/pages/open-datasets/nuscenes/nuscenes.svg',
        front: '/static/images/pages/open-datasets/nuscenes/nuscenes-front.svg',
        back: '/static/images/pages/open-datasets/nuscenes/nuscenes-back.svg'
      },
      href: '/open-av-datasets/nuscenes'
    }
  ]
};

export default HighlightDatasets;
